import React, { useEffect } from "react";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { Stats, Features, AppShowcase, Comparison, Applications, VideoSection, Benefits, Specifications, CtaFooter } from "../components/Sections";

export default function NavigatorPage() {
  const embed = new URLSearchParams(window.location.search).get("embed") === "1";

  useEffect(() => {
    if (window.parent === window) return; // not embedded
    const post = () => {
      try {
        const height = document.documentElement.scrollHeight;
        window.parent.postMessage({ type: "navigator-height", height }, "*");
      } catch (e) {}
    };
    post();
    const ro = new ResizeObserver(post);
    ro.observe(document.body);
    window.addEventListener("load", post);
    const timers = [400, 1200, 2500, 5000].map((t) => setTimeout(post, t));
    return () => { ro.disconnect(); timers.forEach(clearTimeout); };
  }, []);

  return (
    <div className={`bg-[#0A0A0A] text-white ${embed ? "embed-mode" : ""}`} data-testid="navigator-page">
      {!embed && <Navbar />}
      <main>
        <Hero />
        <Stats />
        <Features />
        <AppShowcase />
        <Comparison />
        <Applications />
        <VideoSection />
        <Benefits />
        <Specifications />
        <CtaFooter />
      </main>
    </div>
  );
}
